<h2 mat-dialog-title>Replace</h2>
<h3 *ngIf="totalProducts">Found: {{totalProducts}}</h3>
<h3 *ngIf="totalProducts">Estimate: {{Number(totalProducts / 120 / 60).toFixed(2)}}m</h3>

<mat-dialog-content class="mat-typography">
  <mat-form-field style="width: 100%" class="example-form-field" appearance="fill">
    <mat-label>Find</mat-label>
    <input matInput type="text" [(ngModel)]="from">
  </mat-form-field>
  <br>
  <mat-form-field style="width: 100%" class="example-form-field" appearance="fill">
    <mat-label>Replace</mat-label>
    <input matInput type="text" [(ngModel)]="to">
  </mat-form-field>
  <br>
  <mat-form-field style="width: 100%" class="example-form-field" appearance="fill">
    <mat-label>Limit</mat-label>
    <input matInput type="number" min="0" [(ngModel)]="limit">
  </mat-form-field>
  <br>
  <button style="background-color: coral" mat-raised-button color="primary" (click)="onCheck()">Check</button>
  <pre style="height: 30vh;max-width: 100vw; overflow: scroll;" *ngIf="checkData.length">{{checkData | json}}</pre>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [disabled]="disable" (click)="onSubmit()">Submit</button>
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
